import { escapeHtml } from '../ui.js'
import { apiConfigured, clientActivate } from '../api.js'
import { isClientLoggedIn, setClientSession } from '../clientAuth.js'

export function renderActivate() {
  const invite = new URLSearchParams(window.location.search).get('invite') || ''
  return `
    <div class="portal-card portal-hero">
      <h1>Activar acceso</h1>
      <p class="portal-muted">Define tu contraseña para ver el dashboard de tu instalación.</p>
    </div>
    <div class="portal-card">
      <form id="client-activate-form" novalidate>
        <div class="portal-field">
          <label class="portal-label" for="invite_token">Código de invitación *</label>
          <input class="portal-input" id="invite_token" name="invite_token" value="${escapeHtml(invite)}" required minlength="16" autocomplete="off" />
        </div>
        <div class="portal-field">
          <label class="portal-label" for="password">Contraseña *</label>
          <input class="portal-input" type="password" id="password" name="password" required minlength="8" autocomplete="new-password" />
        </div>
        <div class="portal-field">
          <label class="portal-label" for="password_confirmation">Repetir contraseña *</label>
          <input class="portal-input" type="password" id="password_confirmation" name="password_confirmation" required minlength="8" autocomplete="new-password" />
        </div>
        <button type="submit" class="portal-btn portal-btn-primary portal-btn-block">Activar y entrar</button>
      </form>
      <p id="activate-msg" class="portal-muted portal-form-msg" role="status"></p>
      <p class="portal-muted" style="margin-top:12px">
        ¿Ya tienes acceso? <a href="/cliente" data-link>Inicia sesión</a>.
      </p>
    </div>
  `
}

export function bindActivate(root, { navigate }) {
  if (isClientLoggedIn()) {
    navigate('/mi-instalacion', { replace: true })
    return
  }
  const form = root.querySelector('#client-activate-form')
  const msg = root.querySelector('#activate-msg')
  form?.addEventListener('submit', async (ev) => {
    ev.preventDefault()
    if (!apiConfigured()) {
      msg.textContent = 'Servicio no disponible.'
      return
    }
    const fd = new FormData(form)
    const password = String(fd.get('password') || '')
    const password_confirmation = String(fd.get('password_confirmation') || '')
    if (password !== password_confirmation) {
      msg.textContent = 'Las contraseñas no coinciden.'
      return
    }
    msg.textContent = 'Activando…'
    try {
      const data = await clientActivate(String(fd.get('invite_token') || ''), password, password_confirmation)
      setClientSession({ token: data.token, client: data.client, installations: data.installations })
      navigate('/mi-instalacion', { replace: true })
    } catch (e) {
      msg.textContent = e.message || 'No se pudo activar el acceso.'
    }
  })
}
